import _ from "lodash";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { Button } from "semantic-ui-react";
import "../../assets/style/global-leave.scss";
import { commonConstants } from "../../core/constant/common.constants";
import "./style.scss";

const AllDetailRequest = (props) => {
    const { leaveDetail, handleApprove, handleReject, checkError, flagCancel, isLoadingDetail } = props;
    const dataLeaveDetail = _.assign(leaveDetail);
    const { t } = useTranslation();
    const [flagApprove, setFlagApprove] = useState(true);
    const [flagReject, setFlagReject] = useState(true);
    const [workLog, setWorkLog] = useState([]);
    const history = useHistory();
    const dayFrom = moment(dataLeaveDetail.dayFrom).format("DD/MM/YYYY");
    const dayTo = moment(dataLeaveDetail.dayTo).format("DD/MM/YYYY");
    const timeFrom = moment(dataLeaveDetail.dayFrom).format("HH:mm");
    const timeTo = moment(dataLeaveDetail.dayTo).format("HH:mm");
    const listApprover = dataLeaveDetail.approver2Name;
    const flagPermission = dataLeaveDetail.flagPermission;
    const status = dataLeaveDetail.status;

    const handeleCancel = () => {
        history.push("/all-leave-request");
    };

    const handleApproveRequest = () => {
        handleApprove();
        setFlagReject(true);
        setFlagApprove(true);
    };

    const handleRejectRequest = () => {
        handleReject();
        setFlagReject(true);
        setFlagApprove(true);
    };

    useEffect(() => {
        const checkBtnApprove = () => {
            if (flagPermission === commonConstants.APPROVE && (status === commonConstants.SUBMITTED ||
                status === commonConstants.REJECT)) {
                setFlagApprove(false);
            } else {
                setFlagApprove(true);
            }
        };
        const checkBtnReject = () => {
            if (flagPermission === commonConstants.APPROVE && (status === commonConstants.SUBMITTED || 
                status === commonConstants.APPROVED)) {
                setFlagReject(false);
            
            } else {
                setFlagReject(true);
            }
        };

        checkBtnApprove();
        checkBtnReject();
    }, [status, flagPermission, checkError]);

    useEffect(() => {
        const log = [];
        const logWorkToArr = () => {
            for (const property in dataLeaveDetail.workLog) {
                const _workLog = { date: property, hours: dataLeaveDetail.workLog[property] };
                log.push(_workLog);
            }
        };
        logWorkToArr();
        setWorkLog(log);
      }, [dataLeaveDetail.workLog]);

      const eleWorkLog = workLog.map((item, index) => {
        return (
            <div className="wrapper" key={index}>
                {moment(item.date).isoWeekday() === 6 || moment(item.date).isoWeekday() === 7 ? (
                    <div className="wrapper-input">
                        <p className="weekend">
                            {moment(item.date)
                                .locale(localStorage.getItem("i18nextLng") === "en" ? "en" : "vi")
                                .format("ddd, DD/MM/YYYY")}
                        </p>
                        <p className="hours">{item.hours} </p>
                    </div>
                ) : (
                    <div className="wrapper-input">
                        <p className="week">
                            {moment(item.date)
                                .locale(localStorage.getItem("i18nextLng") === "en" ? "en" : "vi")
                                .format("ddd, DD/MM/YYYY")}
                        </p>
                        <p className="hours"> {item.hours} </p>
                    </div>
                )}
            </div>
        );
      });

    return (
        <div className="all-leave-detail">
            <div className="all-leave-detail-wrapper">
                <h4 className="leave-title">{t("labels.workflowInformation")}</h4>
                <div className="all-leave-detail-wrapper-content">
                    <div className="form-group">
                        <p className="text">{t("labels.requestBy")}:</p>
                        {isLoadingDetail && <p className="text">{dataLeaveDetail.requestByName}</p>}
                    </div>
                    <div className="form-group">
                        <p className="text">{t("labels.requestFor")}:</p>
                        {isLoadingDetail && <p className="text">{dataLeaveDetail.requestForName}</p>}
                    </div>
                    <div className="form-group">
                        <p className="text">{t("labels.managerLeader")}:</p>
                        {isLoadingDetail && <p className="text">{dataLeaveDetail.approver1Name}</p>}
                    </div>
                    <div className="form-group">
                        <p className="text">{t("labels.ccList")}:</p>
                        {isLoadingDetail && (
                            <div className="list-approver">
                                {listApprover &&
                                    listApprover.map((item, index) => {
                                        return (
                                            <p key={index} className="text">
                                                {item}
                                            </p>
                                        );
                                    })}
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div className="all-leave-detail-wrapper">
                <h4 className="leave-title">{t("labels.leaveRequestInformation")}</h4>
                <div className="all-leave-detail-wrapper-content leave-request">
                    <div className="form-group">
                        <div className="form-left">
                            <p className="text">{t("labels.leaveTypeDetail")}:</p>
                        </div>
                        <div className="form-right">
                            <div className="form-input">
                                {isLoadingDetail && <p className="text">{dataLeaveDetail.leaveTypeName}</p>}
                            </div>
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="form-left">
                            <p className="text">{t("labels.leaveFromDate")}:</p>
                        </div>
                        <div className="form-right">
                            <div className="form-input">
                                {isLoadingDetail && <p className="text">{dayFrom}</p>}</div>
                            <div className="remaining-wapper">
                                <div className="remaining-left">
                                    <p className="text">{t("labels.leaveToDate")}:</p>
                                </div>
                                <div className="remaining-right">
                                    <div className="form-input">
                                        {isLoadingDetail && <p className="text">{dayTo}</p>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="form-left">
                            <p className="text">{t("labels.leaveFromTime")}:</p>
                        </div>
                        <div className="form-right">
                            <div className="form-input">
                                {isLoadingDetail && <p className="text">{timeFrom}</p>}</div>
                            <div className="remaining-wapper">
                                <div className="remaining-left">
                                    <p className="text">{t("labels.leaveToTime")}:</p>
                                </div>
                                <div className="remaining-right">
                                    <div className="form-input">
                                        {isLoadingDetail && <p className="text">{timeTo}</p>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="form-left">
                            <p className="text">{t("labels.requestTimeOff")}:</p>
                        </div>
                        <div className="form-right">
                            <div className="form-input">
                                {isLoadingDetail && <p className="text">
                                    {dataLeaveDetail.requestTimeOff} day(s)</p>}
                            </div>
                        </div>
                    </div>
                    <div className="form-group form-group-textarea">
                        <div className="form-left">
                            <p className="text">{t("labels.leaveReason")}:</p>
                        </div>
                        <div className="form-right">
                            {isLoadingDetail && <p className="text">
                                {dataLeaveDetail.leaveReason}</p>}
                        </div>
                    </div>
                    <div className="form-group form-group-textarea">
                        <div className="form-left">
                            <p className="text">{t("labels.comment")}:</p>
                        </div>
                        <div className="form-right">
                            {isLoadingDetail && <p className="text">
                                {dataLeaveDetail.comment}</p>}
                        </div>
                    </div>
                    <div className="form-group form-group-textarea ">
                        <div className="form-left">
                            <p className="text">{t("labels.forLogWork")}:</p>
                        </div>
                        <div className="form-right for-logwork ">
                            <div className="form-input list-week">{isLoadingDetail && eleWorkLog}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="btn-wrapper">
                <Button disabled={flagApprove} 
                    onClick={handleApproveRequest} 
                    className="leave-button left">
                    {t("navigation.approve")}
                </Button>
                <Button disabled={flagReject} 
                    onClick={handleRejectRequest} 
                    className="leave-button-reject center">
                    {t("button.reject")}
                </Button>
                <Button onClick={handeleCancel} disabled={flagCancel} className="right">
                    {t("button.cancel")}
                </Button>
            </div>
        </div>
    );
};

export default AllDetailRequest;
